import React from 'react';
import { Icons } from '../../Icon.jsx';

const VariantListPanel = ({
    layout,
    handleResizeStart,
    loading,
    variants,
    search,
    setSearch,
    handleCreateVariant,
    selectedVariantId,
    setSelectedVariantId,
    bottomRowRef,
    selectedVariant,
    addKey,
    activeKey,
    setActiveKey,
    disabledPreviewKeys,
    toggleVariant,
    removeKey,
    renameKey
}) => {
    return (
        <div
            ref={bottomRowRef}
            className="flex-1 flex min-h-0"
        >
            {/* Bottom-Left: Variant Collections */}
            <div
                className="border-r border-slate-200 flex flex-col bg-slate-50 min-h-0"
                style={{ width: `${layout.collectionsWidth}%` }}
            >
                <div className="p-2 border-b border-slate-200 flex gap-2 shrink-0">
                    <input
                        className="flex-1 text-xs border p-1 rounded"
                        placeholder="Search collections..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                    <button onClick={handleCreateVariant} className="p-1 bg-blue-500 text-white rounded hover:bg-blue-600"><Icons.Plus className="w-4 h-4"/></button>
                </div>
                <div className="flex-1 overflow-y-auto p-2 space-y-1 scrollbar-thin scrollbar-thumb-slate-300">
                    {loading && <div className="text-xs text-gray-400 text-center p-4">Loading...</div>}
                    {!loading && variants.filter(v => (v.name || '').toLowerCase().includes(search.toLowerCase())).map((v, i) => (
                        <div
                            key={v._id || i}
                            onClick={() => setSelectedVariantId(v._id)}
                            className={`p-2 rounded cursor-pointer text-sm flex justify-between items-center group ${selectedVariantId === v._id ? 'bg-blue-100 text-blue-800 font-semibold' : 'hover:bg-slate-100 text-gray-700'}`}
                        >
                            <span>{v.name || 'Untitled'}</span>
                            <span className="text-[10px] bg-slate-200 px-1 rounded text-gray-500 group-hover:bg-white">{(v.styles || []).length} keys</span>
                        </div>
                    ))}
                </div>
            </div>

            {/* Resizer Vertical (Collections vs Keys) */}
            <div
                className="w-1 bg-slate-200 hover:bg-blue-400 cursor-col-resize flex-shrink-0 z-10"
                onMouseDown={(e) => handleResizeStart(e, 'collectionsWidth')}
            />

            {/* Bottom-Right: Defined Keys List */}
            <div className="flex-1 flex flex-col bg-white min-h-0">
                <div className="p-2 border-b border-slate-200 bg-slate-50 flex justify-between items-center shrink-0">
                    <div className="text-[10px] text-gray-500 uppercase font-bold tracking-wider">Variants</div>
                    <button onClick={addKey} disabled={!selectedVariant} className="text-xs flex items-center gap-1 bg-white border border-slate-300 px-2 py-0.5 rounded hover:border-blue-500 hover:text-blue-500 disabled:opacity-50">
                        <Icons.Plus className="w-3 h-3"/> New Key
                    </button>
                </div>
                <div className="flex-1 overflow-y-auto p-2 scrollbar-thin scrollbar-thumb-slate-300">
                    {selectedVariant ? (
                        <>
                            {(selectedVariant.styles || []).length === 0 && <div className="text-xs text-gray-400 italic text-center p-4">No keys defined.</div>}
                            {(selectedVariant.styles || []).map(style => {
                                const isDisabled = disabledPreviewKeys.includes(style.key);
                                return (
                                    <div
                                        key={style.key}
                                        onClick={() => setActiveKey(style.key)}
                                        onDoubleClick={(e) => {
                                            e.stopPropagation();
                                            if (renameKey) renameKey(style.key);
                                        }}
                                        className={`p-2 rounded cursor-pointer text-sm flex justify-between items-center mb-1 group ${activeKey === style.key ? 'bg-blue-100 text-blue-800 font-semibold ring-1 ring-blue-300' : 'hover:bg-slate-100 text-gray-700'}`}
                                    >
                                        <div className="flex items-center gap-2">
                                            <button
                                                onClick={(e) => { e.stopPropagation(); toggleVariant(style.key); }}
                                                className={`p-1 rounded hover:bg-slate-200 ${(style.value && !isDisabled) ? 'text-blue-500' : 'text-gray-400'}`}
                                                title={isDisabled ? "Enable Preview" : "Disable Preview"}
                                            >
                                                {isDisabled ? <Icons.EyeOff className="w-3.5 h-3.5"/> : <Icons.Eye className="w-3.5 h-3.5"/>}
                                            </button>
                                            <span>{style.key}</span>
                                        </div>
                                        <button
                                            onClick={(e) => { e.stopPropagation(); removeKey(style.key); }}
                                            className="p-1 text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
                                            title="Delete Key"
                                        >
                                            <Icons.Trash className="w-3 h-3"/>
                                        </button>
                                    </div>
                                );
                            })}
                        </>
                    ) : (
                        <div className="text-xs text-gray-400 italic text-center p-4">Select a collection first</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VariantListPanel;
